export default "__VITE_ASSET__BpiwrwTx__"